"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestSlice = exports.invokeRequest = exports.selectCachedRequest = exports.selectOnGoingRequest = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const makeKey = (request) => JSON.stringify(request);
const makeUrl = (settings, url) => {
    let requestUrl = settings.API_URL;
    requestUrl += url;
    return requestUrl;
};
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
const selectOnGoingRequest = (state, key) => state.onGoingRequests[key];
exports.selectOnGoingRequest = selectOnGoingRequest;
const selectCachedRequest = (state, key) => state.requestsCache[key];
exports.selectCachedRequest = selectCachedRequest;
const createRequest = (method, url, data, token, options) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const headers = {};
    if (token !== undefined) {
        headers.Authorization = `Bearer ${token}`;
    }
    if (options.requestID !== undefined) {
        headers['x-daisy-request-id'] = options.requestID;
    }
    let body;
    if (data !== undefined) {
        if (options.isFormData) {
            const { files } = data;
            const formData = new FormData();
            Object.keys(files).forEach((key) => {
                if (files[key] instanceof File) {
                    formData.append('file', files[key]);
                }
            });
            body = formData;
        }
        else {
            headers['Content-Type'] = 'application/json';
            body = JSON.stringify(data);
        }
    }
    // fetch only normalizes the case of some methods (not e.g. PATCH)
    const response = yield fetch(url, { method: method.toUpperCase(), headers, body });
    if (!response.ok) {
        throw new Error(response.statusText || `Request failed with status ${response.status}`);
    }
    if (options.isBlob) {
        return response.blob();
    }
    const text = yield response.text();
    const contentType = (_a = response.headers.get('content-type')) !== null && _a !== void 0 ? _a : '';
    return text && contentType.includes('json') ? JSON.parse(text) : text;
});
exports.invokeRequest = (0, toolkit_1.createAsyncThunk)('request/invoke', (options, thunk) => __awaiter(void 0, void 0, void 0, function* () {
    var _b;
    const { method, url } = options;
    const key = makeKey(options);
    const APIurl = makeUrl(thunk.extra.settingsProvider, url);
    const token = thunk.extra.sessionProvider.getToken();
    options.requestID = (_b = thunk.extra.settingsProvider) === null || _b === void 0 ? void 0 : _b.createRequestID();
    // const idToken = thunk.extra.sessionProvider.getIdToken();
    // const tenant = thunk.extra.sessionProvider.getTenant();
    try {
        const body = yield createRequest(method, APIurl, options.data, token, options);
        return { key, body, error: false };
        // return !isBlob(body) ? { key, body, error } : { key, error, body: {} };
    }
    catch (err) {
        return thunk.rejectWithValue({
            key,
            error: err.message
        });
    }
}));
exports.requestSlice = (0, toolkit_1.createSlice)({
    name: 'requests',
    initialState: {
        onGoingRequests: {},
        requestsCache: {},
        requestFail: {},
        isFetching: false
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(exports.invokeRequest.pending, (state, action) => {
            state.onGoingRequests[action.meta.requestId] = action.meta.arg;
            state.isFetching = true;
        })
            .addCase(exports.invokeRequest.fulfilled, (state, action) => {
            delete state.onGoingRequests[action.meta.requestId];
            state.requestsCache[action.payload.key] = action.payload.body;
            state.isFetching = false;
        })
            .addCase(exports.invokeRequest.rejected, (state, action) => {
            delete state.onGoingRequests[action.meta.requestId];
            if (action.payload) {
                state.requestFail[action.payload.key] = action.payload.error;
            }
            state.isFetching = false;
        });
    }
});
exports.default = exports.requestSlice.reducer;
